
import type { PropType } from 'vue'
import type { DispatcherWorkplaceDataEntity, DispatcherWorkplaceDelivery, DispatcherWorkplaceTake } from '@/modules/DispatcherWorkplaceModule/types'

import { defineComponent, computed } from 'vue'

import DwActionSequenceIcon from '@/modules/DispatcherWorkplaceModule/components/DwActionSequenceIcon/index.vue'
import DwMarkerState from './State.vue'

import {
    DELIVERY_MARKER_COLOR,
    UNDELIVERED_DELIVERY_MARKER_COLOR,
    TAKE_MARKER_COLOR,
    UNASSIGNED_TAKE_MARKER_COLOR
} from '@/modules/DispatcherWorkplaceModule/constants'

export default defineComponent({
    components: {
        'dw-action-sequence-icon': DwActionSequenceIcon,
        'dw-marker-state': DwMarkerState
    },
    props: {
        isCourierItem: {
            type: Boolean,
            default: false
        },
        entity: {
            type: Object as PropType<DispatcherWorkplaceDataEntity>,
            required: true
        }
    },
    setup(props) {
        const isEntityCompleted = computed(() => {
            if (props.entity.type === 1) {
                const takeEntity = props.entity as DispatcherWorkplaceTake
                return takeEntity.state === 1 || takeEntity.statusId === 3
            }

            if (props.entity.type === 2) {
                const deliveryEntity = props.entity as DispatcherWorkplaceDelivery
                return deliveryEntity.state === 1
            }

            return false
        })

        const computedColor = computed(() => {
            if (props.entity.type === 1) {
                if ((props.entity as DispatcherWorkplaceTake).notAssigned) {
                    return UNASSIGNED_TAKE_MARKER_COLOR
                }
                
                return TAKE_MARKER_COLOR
            }

            if (props.entity.type === 2) {
                if ((props.entity as DispatcherWorkplaceDelivery).notDelivered) {
                    return UNDELIVERED_DELIVERY_MARKER_COLOR
                }

                return DELIVERY_MARKER_COLOR
            }

            return 'black'
        })

        return {
            isEntityCompleted,
            computedColor
        }
    }
})
